window.Vue = require("vue");
import VueQuagga from "vue-quaggajs";

Vue.use(VueQuagga);
